<template>
  <transition name="modal-fade">
    <span v-if="this.isModalVisible">
      <div class="modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
        <header class="modal-header">
          {{ i18nJS.briefcases_modal_title }}
          <i v-show="loading" class="far fa-spinner fa-spin" />
          <button type="button" class="btn-close" @click="close" aria-label="Close modal">
            <i class="fa-light fa-xmark"></i>
          </button>
        </header>
        <section class="modal-body">
          <div v-if="this.domesticActivities">
            <table class="table fixed_header">
              <thead>
                <tr class="heading">
                  <th>{{ i18nJS.activity_row.date_time }}</th>
                  <th>{{ i18nJS.activity_row.activity }}</th>
                  <th>{{ i18nJS.activity_row.guest }}</th>
                  <th>{{ i18nJS.briefcase_consuption }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="activity in this.domesticActivities" :key="activity.gad_id">
                  <td>{{ activity.gad_start }}</td>
                  <td>{{ activity.gad_desc }}</td>
                  <td>{{ activity.gad_fullname }}</td>
                  <td>
                    <template v-for="gadItem in activity.gad_items">
                      <li v-if="!gadItem._destroy" :key="gadItem.desc">
                        <span>
                          <input type="number" min="1" class="input-micro" placeholder="Qta" v-model="gadItem.qta" />
                          {{ gadItem.desc }}
                        </span>
                        <a class="delete-icon" @click="() => $set(gadItem, '_destroy', true)">
                          <i class="fa-light fa-trash-can"></i>
                        </a>
                      </li>
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else id="no-visit">
            {{ i18nJS.no_activity }}
          </div>
          <span v-if="errorData" class="span-error">
            {{ i18nJS.briefcase_error }}
          </span>
        </section>
        <footer class="modal-footer">
          <button type="button" class="btn btn-primary secondary" @click="close" aria-label="Close modal">
            {{ i18nJS.command.annull }}
          </button>
          <button type="button" @click="saveActivityBriefcases" class="btn btn-success" aria-label="Save modal">
            {{ i18nJS.command.save }}
          </button>
        </footer>
      </div>
      <div class="modal-backdrop"></div>
    </span>
  </transition>
</template>
<script>
import apiConnector from '@/epersonam/apiConnector';
export default {
  name: 'briefcasesDiscarge',
  props: ['discargeActivitiesBriefcasesUrl'],
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  data() {
    return {
      loading: false,
      errorData: false,
      isModalVisible: false,
      activityIds: [],
      domesticActivities: [],
    };
  },
  mounted() {
    eventBus.$on('activity_discarge_briefcase_ids', (activity_ids) => {
      this.activityIds = activity_ids;
      this.getActivityBriefcases();
    });
    this.errorData = false;
    $(document).on('click', `[data-toggle='briefcases-discarge'], [data-target='${this.targetModal}']`, () => {
      this.isModalVisible = true;
    });
  },
  methods: {
    getActivityBriefcases() {
      this.errorData = false;
      this.loading = true;
      apiConnector()
        .get(`/${window.locale}/guest_activity_domestic_briefcases.json?gad_ids=${this.activityIds.join(',')}`)
        .then((res) => {
          this.loading = false;
          this.domesticActivities = res.data;
        })
        .catch((err) => {
          this.loading = false;
          this.errorData = true;
        });
    },
    saveActivityBriefcases() {
      this.loading = true;
      apiConnector()
        .post(this.discargeActivitiesBriefcasesUrl, { activities: this.domesticActivities })
        .then((res) => {
          this.loading = false;
          window.alert('Scarico Completato');
          this.close();
        })
        .catch((err) => {
          this.loading = false;
          this.errorData = true;
        });
    },
    close() {
      this.loading = false;
      this.errorData = false;
      this.isModalVisible = false;
      this.activityIds = [];
      this.domesticActivities = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.vmodal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal {
  left: 15%;
  width: 70%;
  margin-left: 0;
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
}
.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}
.modal-header {
  display: flex;
  padding: 15px;
  border-bottom: 1px solid #eeeeee;
  color: #ef7b12;
  justify-content: space-between;
}
.modal-footer {
  border-top: 1px solid #eeeeee;
  justify-content: flex-end;
}
.modal-body {
  position: relative;
  padding: 20px 10px;
}
.btn-close {
  border: none;
  font-size: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #ef7b12;
  background: transparent;
}
.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}
.graycolor {
  color: #999;
}
.blackcolor {
  color: #0000;
}
.span-error {
  font-size: 13px;
  color: red;
  margin-left: 29px;
}
.delete-icon {
  margin-top: 10px;
  float: right;
}
</style>
